import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// Tracking clicks on the expand button in SAIN answer cards
export const aiAnswerExpandClicked: (
	props: commonAttributesType & { jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink' },
) => AnalyticsEventPayload = (
	props: commonAttributesType & { jiraNlToJqlCardVariant?: 'issue-table' | 'smartlink' },
): AnalyticsEventPayload => {
	const { query, answerString, source, jiraNlToJqlCardVariant } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerExpand',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			jiraNlToJqlCardVariant,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
